import React, { Component, Fragment  } from 'react';
import './BorrarActivo.css'; 
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import MyButton from '../../../utils/MyButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import DialogTitle from '@material-ui/core/DialogTitle';


import { FaArrowLeft,FaTrash } from "react-icons/fa";

import {deleteActivo,clearErrors} from '../../../redux/actions/mobiliarioactions';

export class BorrarActivo extends Component {

  
    constructor(){
        super();
        this.state={
            fecha:'',
            hora:'',
            duracion:'',
            errors:{},
            open:false
        };
        
    };
    static getDerivedStateFromProps(props, state) {
      return props.UI.errors ? {errors: props.UI.errors} : null;
  }


    handleOpenDelete=()=>{
        this.setState({opendelete:true});
       
        };
  
  handleCloseDelete=()=>{
           // this.props.clearErrors();
            this.setState({opendelete:false,errors:{}});
            };
  handleDelete=()=>{
  
 this.props.deleteActivo(this.props.clienteId,this.props.mobiliarioId,this.props.history);
 // this.handleCloseDelete();
  }

    

    render() {
        const { UI:{loading}}=this.props; 
        const {errors}=this.state;

        return (
            <div>
                <Fragment>
            <MyButton tip="Borrar Activo" onClick={this.handleOpenDelete}>
            <FaTrash color="#03178C" className="icon-crearcliente"/>
             </MyButton>

             <Dialog
             open={this.state.opendelete}
             onClose={this.handleCloseDelete}
             fullWidth
            maxWidth="sm"
            >
            <DialogTitle>Estas seguro de borrar este Activo?</DialogTitle>

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseDelete}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
              
                          <MyButton tip="Borrar Activo" onClick={this.handleDelete}>
                          <FaTrash color="#03178C" className="icon-formulario"/>
                           </MyButton>
           </DialogActions>
            </Dialog>

  

             </Fragment>

            </div>
        )
    }
}

BorrarActivo.propTypes={
    deleteActivo:PropTypes.func.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired
  };
  const mapStateToProps=(state)=>({
    UI:state.UI,
    mobiliario: state.dataMob.mobiliario.credentials
  });
  
  export default connect (mapStateToProps,{deleteActivo,clearErrors}) (BorrarActivo)
  
  
